import { AppProviderContext } from '@websrc/App/AppContext'
import { useContext } from 'react'

export const usePath = () => {
  let { path } = useContext(AppProviderContext)

  if (!path.startsWith('/')) {
    path = `/${path}`
  }

  return path
}
